import { lazy } from 'react';

export const PlayerReportBonusRequestForm = lazy(
  () => import('./PlayerReportBonusRequestForm'),
);
